<template>
  <div class="privacy-container">
    <div class="privacy-header">
      <h1>军招助手隐私政策</h1>
    </div>
    <div class="privacy-content">
      <p>军招助手尊重并保护所有使用本软件的用户的个人隐私权。为了给您提供更准确、更有个性化的服务，军招助手会按照本隐私权政策的规定使用和披露您的个人信息。但军招助手将以高度的勤勉、审慎义务对待这些信息。除本隐私权政策另有规定外，在未征得您事先许可的情况下，军招助手不会将这些信息对外披露或向第三方提供。军招助手会不时更新本隐私权政策。</p>
      <p>您在同意军招助手络服务使用协议之时，即视为您已经同意本隐私权政策全部内容。本隐私权政策属于军招助手络服务使用协议不可分割的一部分。</p>
      <p>另外，您需要承诺在您开始使用本产品时已经是成年人、如果您是未成年人，需要您的监护人同意您使用本产品并同意相关的服务条款和隐私政策。</p>
      
      <h4>1.怎样收集并使用您的信息（包括个人信息）</h4>
      <p>个人信息是指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息，其中属于个人敏感信息的包括个人生物识别信息（例如指纹、面部、声纹）、身份证件号码、银行账号、财产信息、交易信息、行踪轨迹（例如居住和办公地址）等。</p>
      <p>我们只会以该声明中所列出的目的，来收集和使用您的信息：</p>
      <p>a) 拨打电话与发送信息：军招助手为了能够实现拨打电话以及发送信息的功能，我们需要收集您的以下信息：通讯录中的联系人姓名、假名化后的设备标识符、移动网络代码和移动设备国家代码。您的联系人的组别属性、名称以及电话号码仅存储在本地进行处理，不会上传到服务器。</p>
      <p>b) 查询天气和预约任务：军招助手为了能够实现查询天气和预约任务中跟地点相关的功能，我们需要收集您的地理位置信息，包括但不限于：当前位置、常访问位置、居住地址以及办公/学习位置。</p>
      <p>c) 查询与设置日程：军招助手为了能够实现查询与设置日程的功能，我们需要收集并处理您的日历信息。该信息的收集和处理仅在本地完成，用于查询和设置您的日程。</p>
      <p>d) 调用第三方应用：为了提供更为丰富的服务，军招助手会通过云端与第三方应用开放接入接口。由三方服务方应用为您提供相应的服务（例如：导航、订机变等）、我们会将第三方服务方/应用所需要的信息提供给对方，包括但不限于：语音识别结果（文字信息）、位置信息。（在使用的功能涉及第三方时，可能会跳转到第三方应用或网站上，我们强烈建议您仔细阅读该第三方的服务条款和隐私政策，因为我们无法控制第三方应用或网站，也不为第三方损害您的权益承担任何责任。）</p>
      
      <h4>2.保留政策与数据存储</h4>
      <p>如果有必要实现收集信息的目的，或者遵守适用法律要求或者允许，我们将一直保留个人信息，只要能够合理断出保留个人信息无法实现收集信息的目的，我们将不会再保留个人信息，或者会消除将个人信息和特定个人关联在一起的途径。</p>
      <p>a) 数据存储地点：我们在本产品和服务中所收集和产生的个人信息，将存储在中华人民共和国境内。</p>
      <p>b) 数据存储期限：我们仅为实现上述目的所需要的时间来保留您的个人信息，并在超出保留时间后删除或匿名化处理您的个人信息；但法律法规另有要求的除外。（另外，如果我们的产品或服务发生了停止运营的情况时，我们将以推送通知、公告等形式告知您，并在合理的期限内删除您的个人信息或进行匿名化处理。）</p>
      
      <h4>3.适用范围</h4>
      <p>a) 在您注册军招助手帐号时，您根据军招助手要求提供的个人注册信息（商家应法律法规要求需公示的企业名称及相关工商注册信息除外）；</p>
      <p>b) 在您使用军招助手网络服务，或访问军招助手平台网页时，军招助手自动接收并记录的您的浏览器和计算机上的信息，包括但不限于您的IP地址、浏览器的类型、使用的语言、访问日期和时间、软硬件特征信息及您需求的网页记录等数据；</p>
      <p>c) 军招助手通过合法途径从商业伙伴处取得的用户个人数据。</p>
      <p>您了解并同意，以下信息不适用本隐私权政策：</p>
      <p>a) 您在使用军招助手平台提供的搜索服务时输入的关键字信息；</p>
      <p>b) 军招助手收集到的您在军招助手发布的有关信息数据，包括但不限于参与活动、成交信息及评价详情；</p>
      <p>c) 违反法律规定或违反军招助手规则行为及军招助手已对您采取的措施。</p>
      
      <h4>4.信息使用</h4>
      <p>a) 军招助手不会向任何无关第三方提供、出售、出租、分享或交易您的个人信息，除非事先得到您的许可，或该第三方和军招助手（含军招助手关联公司）单独或共同为您提供服务，且在该服务结束后，其将被禁止访问包括其以前能够访问的所有这些资料。</p>
      <p>b) 军招助手亦不允许任何第三方以任何手段收集、编辑、出售或者无偿传播您的个人信息。任何军招助手平台用户如从事上述活动，一经发现，军招助手有权立即终止与该用户的服务协议。</p>
      <p>c) 为服务用户的目的，军招助手可能通过使用您的个人信息，向您提供您感兴趣的信息，包括但不限于向您发出产品和服务信息，或者与军招助手合作伙伴共享信息以便他们向您发送有关其产品和服务的信息（后者需要您的事先同意）。</p>
      
      <h4>5.信息披露</h4>
      <p>在如下情况下，军招助手将依据您的个人意愿或法律的规定全部或部分的披露您的个人信息：</p>
      <p>a) 经您事先同意，向第三方披露；</p>
      <p>b) 为提供您所要求的产品和服务，而必须和第三方分享您的个人信息；</p>
      <p>c) 根据法律的有关规定，或者行政或司法机构的要求，向第三方或者行政、司法机构披露；</p>
      <p>d) 如您出现违反中国有关法律、法规或者军招助手服务协议或相关规则的情况，需要向第三方披露；</p>
      <p>e) 如您是适格的知识产权投诉人并已提起投诉，应被投诉人要求，向被投诉人披露，以便双方处理可能的权利纠纷；</p>
      <p>f) 在军招助手平台上创建的某一交易中，如交易任何一方履行或部分履行了交易义务并提出信息披露请求的，军招助手有权决定向该用户提供其交易对方的联络方式等必要信息，以促成交易的完成或纠纷的解决。</p>
      <p>g) 其它军招助手根据法律、法规或者网站政策认为合适的披露。</p>
      
      <h4>6.信息存储和交换</h4>
      <p>军招助手收集的有关您的信息和资料将保存在军招助手及（或）其关联公司的服务器上，这些信息和资料可能传送至您所在国家、地区或军招助手收集信息和资料所在地的境外并在境外被访问、存储和展示。</p>
      
      <h4>7.Cookie的使用</h4>
      <p>a) 在您未拒绝接受cookies的情况下，军招助手会在您的计算机上设定或取用cookies，以便您能登录或使用依赖于cookies的军招助手平台服务或功能。军招助手使用cookies可为您提供更加周到的个性化服务，包括推广服务。</p>
      <p>b) 您有权选择接受或拒绝接受cookies。您可以通过修改浏览器设置的方式拒绝接受cookies。但如果您选择拒绝接受cookies，则您可能无法登录或使用依赖于cookies的军招助手网络服务或功能。</p>
      <p>c) 通过军招助手所设cookies所取得的有关信息，将适用本政策。</p>
      
      <h4>8.信息安全</h4>
      <p>a) 军招助手帐号均有安全保护功能，请妥善保管您的用户名及密码信息。军招助手将通过对用户密码进行加密等安全措施确保您的信息不丢失，不被滥用和变造。尽管有前述安全措施，但同时也请您注意在信息网络上不存在“完善的安全措施”。</p>
      <p>b) 在使用军招助手网络服务进行网上交易时，您不可避免的要向交易对方或潜在的交易对方披露自己的个人信息，如联络方式或者邮政地址。请您妥善保护自己的个人信息，仅在必要的情形下向他人提供。如您发现自己的个人信息泄密，尤其是军招助手用户名及密码发生泄露，请您立即联络军招助手客服，以便军招助手采取相应措施。</p>
      
      <h4>9.获取的权限及说明</h4>
      <p>a) 获取设备信息（IMEI标识/MAC地址/网络状态）权限：用于账号的登录及注册功能；</p>
      <p>b) 访问您设备上的照片、媒体内容和文件权限：存储及读取程序的缓存内容和账号信息数据；</p>
      <p>c) 拨打电话和管理通话权限：用于联系客服（拨打客服电话）功能；</p>
      <p>d) 拍摄照片及录制视频权限：用户用户头像上传功能；</p>
      
      <h4>10.账号的注销</h4>
      <p>用户可以联系客服申请注销自己的账号服务，账号注销操作不可逆，我们将会在3个工作日内完成注销。</p>
      
      <h4>11.更新说明</h4>
      <p>军招助手保留随时更新本声明的权利，当声明发生修改时，我们会通过弹窗或通知的方式告知您变更后的声明。如您继续使用我们的服务，即视为您同意我们的变更后的隐私政策，我们才会按照更新的声明收集、使用、存储您的个人信息。</p>
    </div>
  </div>
</template>

<script setup>
</script>

<style scoped>
.privacy-container {
  min-height: 100vh;
  background: #f5f7fa;
  padding: 40px 20px;
}

.privacy-header {
  text-align: center;
  margin-bottom: 40px;
}

.privacy-header h1 {
  font-size: 28px;
  font-weight: 600;
  color: #303133;
}

.privacy-content {
  max-width: 800px;
  margin: 0 auto;
  background: #fff;
  padding: 40px;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.privacy-content h3 {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 16px;
  text-align: center;
}

.privacy-content h4 {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
  margin-top: 24px;
  margin-bottom: 12px;
}

.privacy-content p {
  font-size: 14px;
  color: #606266;
  line-height: 1.8;
  margin-bottom: 12px;
  text-align: justify;
  text-indent: 2em;
}

@media (max-width: 768px) {
  .privacy-container {
    padding: 20px 15px;
  }
  
  .privacy-header h1 {
    font-size: 22px;
  }
  
  .privacy-content {
    padding: 20px;
  }
  
  .privacy-content h4 {
    font-size: 15px;
    margin-top: 20px;
  }
  
  .privacy-content p {
    font-size: 13px;
    line-height: 1.6;
  }
}
</style>
